module.exports = __webpack_public_path__ + "img/img12.a8f0a61a.png";